export default "__VITE_ASSET__DM_kMIrC__"